
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class PulseWaveEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const count = Math.floor(5 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;

        const draw = () => {
            for (let i = 0; i < count; i++) {
                const life = (curTime * 0.5 + i / count) % 1;
                const r = life * Math.max(width, height) * 1.5 * scale;
                const alpha = (1 - life) * 0.6;
                
                ctx.save();
                ctx.globalAlpha = alpha / layerIndex;
                ctx.lineWidth = (10 * (1 - life)) * scale;
                ctx.beginPath();
                ctx.arc(0, 0, r, 0, Math.PI * 2);
                ctx.stroke();
                
                // Jagged interference on the ring
                ctx.lineWidth = 1 * scale;
                ctx.beginPath();
                for (let a = 0; a < Math.PI * 2; a += 0.1) {
                    const dr = Math.sin(a * 20 + curTime * 10) * 10 * scale;
                    const px = Math.cos(a) * (r + dr);
                    const py = Math.sin(a) * (r + dr);
                    if (a === 0) ctx.moveTo(px, py);
                    else ctx.lineTo(px, py);
                }
                ctx.stroke();
                ctx.restore();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
